// src/main.ts

// Import the explicit router initializer instead of relying on side-effects
import { initRouter } from "./router";

import "../index.css";
import "./pages/Home.css";

import { useAuth } from "./context/useAuth";
import { useTheme } from "./context/useTheme";

/**
 * Orchestrates the application bootstrap process in the correct sequence.
 */
async function bootstrap() {
  try {
    // 1. Initialize Authentication state before rendering anything
    const { init } = useAuth();
    await init();

    // 2. Fetch and apply user theme configuration
    const { theme, applyTheme } = useTheme();
    applyTheme(theme);

    // 3. Start the single-page router now that app state is ready
    initRouter();
  } catch (error) {
    console.error("Application bootstrap failed:", error);
  }
}

// Execute immediately if the DOM is already interactive/complete,
// otherwise attach to the DOMContentLoaded event listener.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrap);
} else {
  bootstrap();
}
